import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("date-picker", () => {
    it("should render and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-date-picker />`);
        const el = await page.find("ux-date-picker");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should format date correctly and open calendar with selected date on click", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-date-picker date-format="DD.MM.YYYY" value="15.03.2021" language="de" name="test-date" />`
        );
        const dateSelected = await page.spyOnEvent("uxDateSelect");
        const el = await page.find("ux-date-picker");
        await page.waitForChanges();
        let calendar = await page.find(".ux-date-picker__container");
        expect(calendar).toBeNull();
        const field = await el.find(".ux-date-picker__field");
        await field.click();
        await page.waitForChanges();
        calendar = await page.find(".ux-date-picker__container");
        expect(calendar).not.toBeNull();

        // current day
        let day = await page.find(
            '.ux-date-picker__calendar-day-btn[data-day="2021-03-15"]'
        );
        expect(day.getAttribute("aria-selected")).not.toBeNull();

        // select other day
        day = await page.find(
            '.ux-date-picker__calendar-day-btn[data-day="2021-03-20"]'
        );
        expect(day.getAttribute("aria-selected")).toBeNull();
        expect(day).not.toBeNull();
        await day.click();
        await page.waitForChanges();
        calendar = await page.find(".ux-date-picker__container");
        expect(calendar).toBeNull();
        expect(dateSelected).toHaveReceivedEventDetail({
            name: "test-date",
            value: "2021-03-20",
        });
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-date-picker />`);
    });
});
